import { useState, useEffect } from 'react'
import { NavigationProps } from '../types'
import './Header.css'

const navItems: NavigationProps['items'] = [
  { id: 'hero', label: 'Hem' },
  { id: 'about', label: 'Om mig' },
  { id: 'services', label: 'Behandlingar' },
  { id: 'contact', label: 'Kontakt' },
]

interface HeaderProps {
  activeSection: string
  onNavigate: (sectionId: string) => void
}

export default function Header({ activeSection, onNavigate }: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20)
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleNavClick = (sectionId: string) => {
    onNavigate(sectionId)
    setIsMobileMenuOpen(false)
  }

  return (
    <header
      className={`header ${isScrolled ? 'header--scrolled' : ''}`}
      role="banner"
    >
      <div className="header__inner container">
        <a
          href="#hero"
          className="header__logo"
          aria-label="Catarina Malmberg - Psykoterapeut, gå till startsidan"
          onClick={(e) => {
            e.preventDefault()
            handleNavClick('hero')
          }}
        >
          <span className="header__logo-text">Catarina Malmberg</span>
          <span className="header__logo-subtitle">Psykodynamisk samtalsterapeut</span>
        </a>

        <nav className={`header__nav ${isMobileMenuOpen ? 'header__nav--open' : ''}`} role="navigation" aria-label="Huvudnavigering">
          <ul className="header__nav-list">
            {navItems.map((item) => (
              <li key={item.id} className="header__nav-item">
                <button
                  className={`header__nav-btn ${activeSection === item.id ? 'header__nav-btn--active' : ''}`}
                  onClick={() => handleNavClick(item.id)}
                  aria-current={activeSection === item.id ? 'page' : undefined}
                >
                  {item.label}
                </button>
              </li>
            ))}
            <li className="header__nav-item header__nav-item--cta">
              <a href="#contact" className="btn btn--primary" onClick={() => handleNavClick('contact')}>
                Boka tid
              </a>
            </li>
          </ul>
        </nav>

        <button
          className="header__mobile-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-expanded={isMobileMenuOpen}
          aria-controls="main-navigation"
          aria-label={isMobileMenuOpen ? 'Stäng meny' : 'Öppna meny'}
        >
          <span className="header__hamburger" aria-hidden="true">
            <span className="header__hamburger-line" />
            <span className="header__hamburger-line" />
            <span className="header__hamburger-line" />
          </span>
        </button>
      </div>
    </header>
  )
}